module.exports = __webpack_public_path__ + "img/970.0f04c646.png";